"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var handleEvent_1 = require("../assets/handleEvent");

var withResponsive_1 = require("../decorators/withResponsive");

var HiddenResponsive_1 = __importDefault(require("../HiddenResponsive/HiddenResponsive"));

var Margin_1 = __importDefault(require("../Margin/Margin"));

var Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));

function isRenderFunction(arg) {
  return typeof arg === 'function';
}

var TooltipWrapper =
/** @class */
function (_super) {
  __extends(TooltipWrapper, _super);

  function TooltipWrapper(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      showTooltip: false,
      showMobile: false
    };

    _this.onFocus = function () {
      handleEvent_1.handleEvent(_this.props.onFocus);

      _this.setState({
        showTooltip: true,
        showMobile: true
      });
    };

    _this.onBlur = function () {
      handleEvent_1.handleEvent(_this.props.onBlur);

      _this.setState({
        showTooltip: false
      });
    };

    _this.isHasNotPropShow = function () {
      var showTooltip = _this.props.showTooltip;
      return typeof showTooltip === 'undefined' || showTooltip === null;
    };
    /* istanbul ignore next line */


    if (props.dangerFocus) {
      _this.state = {
        showTooltip: true,
        showMobile: true
      };
    }

    return _this;
  }

  TooltipWrapper.prototype.showChildren = function () {
    var children = this.props.children;

    if (isRenderFunction(children)) {
      return children({
        onFocus: this.onFocus,
        onBlur: this.onBlur
      });
    }

    return children;
  };

  TooltipWrapper.prototype.render = function () {
    var _a = this.props,
        testId = _a.testId,
        tooltip = _a.tooltip,
        propsShowTooltip = _a.showTooltip,
        responsive = _a.responsive;
    var show = (this.isHasNotPropShow() ? this.state.showTooltip : propsShowTooltip) && tooltip !== null;
    var mobileShow = (this.isHasNotPropShow() ? this.state.showMobile : propsShowTooltip) && tooltip !== null;
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Tooltip_1.default, {
      testId: testId && testId + "__tooltip-wrapper",
      visible: show,
      delay: 0,
      arrow: true,
      placement: "right",
      reservePlacement: "bottom",
      overlay: tooltip,
      onlyDesktop: true
    }, this.showChildren()), react_1.default.createElement(HiddenResponsive_1.default, {
      responsive: responsive,
      type: "desktop"
    }, mobileShow && react_1.default.createElement(Margin_1.default, {
      mobile: 12,
      desktop: 0
    }), react_1.default.createElement("div", {
      "data-test-id": "mobile-tooltip",
      style: {
        display: mobileShow ? 'block' : 'none'
      }
    }, tooltip)));
  };

  TooltipWrapper = __decorate([withResponsive_1.withResponsive], TooltipWrapper);
  return TooltipWrapper;
}(react_1.default.Component);

exports.default = TooltipWrapper;